<template>
    <div
        ref="player"
        component="Mp3Player"
        :size="size"
        :data-file="file"
        :loading="loading"
        :playing="playing"
        @click="playPause"
    >
        <i class="material-icons" ref="icon">play_arrow</i>
        <span>{{ text }}</span>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatsApi } from '@/api';

export default {
    name: 'Mp3Player',

    data() {
        return {
            loading: false,
            playing: false,
        };
    },

    props: {
        visualizer: {
            type: String,
            required: true,
        },

        file: {
            type: String,
            required: true,
        },

        text: {
            type: String,
            required: false,
        },

        size: {
            type: String,
            required: false,
        },
    },

    methods: {
        playPause() {
            if (!this.playing) {
                StatsApi.incrementVoice(this.file);

                this.$bus.$emit('visualizer.stop.all');

                this.loading = true;

                this.$bus.$emit('visualizer.play', {
                    name: this.visualizer,
                    target: this.$refs.player,
                    unmuteOnUserAction: true,
                    onLoad: () => (this.loading = false),
                    onPlay: () => (this.playing = true),
                    onStop: () => (this.playing = false),
                });
            } else {
                this.$bus.$emit('visualizer.stop', {
                    name: this.visualizer,
                });
            }
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='Mp3Player'] {
    position: relative;
    background-clip: padding-box;
    .flex-center;
    flex-direction: column;
    cursor: pointer;
    // min-width: 60px;

    i {
        position: relative;
        width: 30px;
        height: 30px;
        min-width: 30px;
        min-height: 30px;
        .gradientDark;
        .radiusCircle;
        color: @white;
        transition: 0.3s;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 3px;

        &:before {
            .iconfont;
            content: 'pause';
            position: absolute;
            color: @dark;
            opacity: 0;
        }

        &:after {
            .fullFillBground;
            .gradientLighten;
            .radiusCircle;
            opacity: 0;
            transition: 0.3s;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
        }
    }

    span {
        font-size: 11px;
        letter-spacing: 0.05em;
        font-weight: 900;
        text-transform: uppercase;
        color: @black;
        text-align: center;
    }

    &:hover {
        i:after {
            opacity: 1;
        }
    }
}

// &[size] --------------------------------

[component='Mp3Player'] {
    &[size='big'] {
        i {
            width: 45px;
            height: 45px;
            min-width: 45px;
            min-height: 45px;
        }
    }

    &[size='smaller'] {
        i {
            width: 25px;
            height: 25px;
            min-width: 25px;
            min-height: 25px;
            font-size: 20px;
        }
    }
}

// &[tpos] --------------------------------

[component='Mp3Player'] {
    &[tpos='none'] {
        span {
            display: none;
        }
    }

    &[tpos='top'] {
        flex-direction: column-reverse;
    }

    &[tpos='left'] {
        flex-direction: row-reverse;
        span {
            max-width: 80px;
            text-align: right;
        }
    }

    &[tpos='right'] {
        flex-direction: row;
        span {
            max-width: 80px;
            text-align: left;
        }
    }
}

// &[state] --------------------------------

[component='Mp3Player'] {
    &[loading] {
        pointer-events: none;

        i {
            color: transparent;
            position: relative;

            &:after {
                content: '';
                width: 15px;
                height: 15px;
                border-radius: 50%;
                border-style: solid;
                border-width: 2px;
                border-color: fade(@white, 75%) fade(@white, 75%) fade(@black, 75%) fade(@black, 75%);
                animation: load 1s linear infinite;
                display: inline-block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                opacity: 1;
                transition: 0s;

                @keyframes load {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
            }
        }
    }

    &[playing] {
        border-color: @dark;
        color: @dark;

        span {
            color: @dark;
        }

        i {
            color: transparent;
            background: transparent;

            &:before {
                opacity: 1;
            }

            &:after {
                content: '';
                width: 26px;
                height: 26px;
                border-radius: 50%;
                border-style: solid;
                border-width: 2px;
                border-color: #ffffffbf #ffffffbf #ffffffbf #000000;
                animation: load 5s linear infinite;
                display: inline-block;
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
                opacity: 1;
                // .gradientDarken;
                background: transparent;

                @media (orientation: landscape) {
                    // border-color: #ffffffbf #ffffffbf #ffffffbf #000000;
                }

                @keyframes load {
                    0% {
                        transform: rotate(0deg);
                    }
                    100% {
                        transform: rotate(360deg);
                    }
                }
            }
        }

        &[size='big'] {
            i {
                color: transparent;
                &:before {
                    opacity: 1;
                }

                &:after {
                    content: '';
                    width: 43px;
                    height: 43px;
                }
            }
        }
    }

    &[state='error'] {
        pointer-events: none;
        border-color: @error;
        color: @white;

        i {
            color: transparent;
            &:before {
                opacity: 1;
                content: 'not_interested';
                color: fade(@white, 50%);
            }
        }
    }
}
</style>
